module.exports = __webpack_public_path__ + "img/pingActive.e32cf99d.png";